module.exports = __webpack_public_path__ + "static/media/homepage.e328175e.png";